import { useParams, useSearchParams } from 'react-router-dom';

import DeleteAccountConfirmation from './components/DeleteAccountPageConfirmation/DeleteAccountPageConfirmation';
import DeleteAccountPageHeaderMeta from './components/DeleteAccountPageHeaderMeta/DeleteAccountPageHeaderMeta';

const DeleteAccountPage = () => {
    const { bidderId } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    return (
        <div className="mx-auto flex max-w-[1644px] px-sm pt-lg pb-lg smMin:px-md">
            <DeleteAccountPageHeaderMeta />
            <DeleteAccountConfirmation
                bidderId={Number(bidderId)}
                token={token}
            />
        </div>
    );
};

export default DeleteAccountPage;
